export const FETCH_PROMPT_TITLE = "api/prompt/getprompttitle";
export const FETCH_ALL_CHAT_THREADS = (userId,assistantIdLinked) => `api/prompt/fetchchatthreads/${userId}?assistantId=${assistantIdLinked}`;
export const DELETE_A_CHAT_THREAD = () => "/api/prompt/clearsingleconversation/";
export const UPDATE_A_CHAT_THREAD = () => "/api/prompt/updateprompttitle";
export const UPDATE_LAST_PROMPT = (promptId) => `/api/prompt/${promptId}/last-response`;